import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { authService, hasAcceptedTerms } from "../services/auth";
import { Skeleton, EmptyState, Button } from "./ui";
import { Link } from "react-router-dom";

/** ต้องล็อกอิน + ยอมรับข้อกำหนดครั้งแรก (ยังไม่ยอมรับ -> /terms?next=...) */
export function RequireAuth({ children }) {
  const { isLoggedIn, profile } = useAuth();
  const location = useLocation();
  if (!isLoggedIn) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  if (!hasAcceptedTerms(profile)) {
    return <Navigate to={`/terms?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }
  return children || <Outlet />;
}

/** ต้องเป็น super_user — ถาม Backend ทุกครั้งที่เข้า (ไม่เชื่อค่าใน localStorage) */
export function RequireSuperUser({ children }) {
  const { isLoggedIn } = useAuth();
  const [state, setState] = useState("checking");
  useEffect(() => {
    let alive = true;
    authService.verifySuperUser().then((ok) => alive && setState(ok ? "ok" : "denied")).catch(() => alive && setState("denied"));
    return () => { alive = false; };
  }, [isLoggedIn]);

  if (state === "checking") return <div className="stack"><Skeleton height={28} width="40%" /><Skeleton height={120} /></div>;
  if (state === "denied") {
    return (
      <EmptyState icon="🔒" title="ไม่มีสิทธิ์เข้าหน้านี้" action={<Link to="/"><Button variant="primary">กลับหน้าแรก</Button></Link>}>
        เฉพาะบัญชีผู้ดูแลระบบ (super_user)
      </EmptyState>
    );
  }
  return children || <Outlet />;
}
